<template>
  <div class="app-container">

    <!-- 工具栏 -->
    <div class="filter-container">
      <el-button size="small" class="filter-item" type="danger" disabled>批量删除</el-button>
      <div class="" style="float:right;margin-right:1%;margin-top:10px;">
        <el-popover width="500" trigger="click">
          <el-button slot="reference" size="mini" icon="el-icon-s-grid" style="font-size: 16px;padding:5px 10px;" title="筛选列"><i class="el-icon-caret-bottom"></i></el-button>
          <template>
            <div v-for="(listdis) in columnNamearr" :key="listdis.label">
              <div class="shaixuanlielist" @click='tablelistdis(listdis)' :class="listdis.show?'shaixuantextcolor':''">
                <el-checkbox v-model="listdis.show" style="margin-right:5px;"></el-checkbox>{{listdis.label}}
              </div>
            </div>
          </template>
        </el-popover>
      </div>
    </div>

    <!-- table 列表 -->
    <el-table :header-cell-style="{background:'#eef1f6',color:'#606266',fontSize:'12px'}" border fit v-loading="listLoading" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
      max-height="500px" @selection-change="handleSelectionChange">

      <el-table-column type="selection" fixed width="55" ></el-table-column>

      <el-table-column v-for="item in columnNamearr" :key="item.label" :label="item.label" :min-width="item.label == 'id' ? '90px' : '150px'" style="width: 100%"
        v-if="item.show">
        <template slot-scope="scope">
            <span v-if="scope.row[item.label] && scope.row[item.label].length > 15">
              <el-tooltip placement="top">
                <div slot="content">{{scope.row[item.label]}}</div>
                <div>{{ scope.row[item.label] | neirongsuojian }}</div>
              </el-tooltip>
            </span>
            <span v-else>{{scope.row[item.label]}}</span>
        </template>
      </el-table-column>

      <!-- 操作 -->
      <el-table-column label="操作" width="160px" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" style="padding: 4px 15px;" type="primary" disabled>编辑</el-button>
          <el-button size="mini" style="padding: 4px 15px;" type="danger" disabled>删除</el-button>
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>

<script>
import { ajax_dataworkconfigcolumn } from '@Sys~/api/sys'
export default {
  props: {
    infotableName: {
      type: String,
      default: ''
    }
  },
  filters: {
    neirongsuojian(value) {
      if (value != "") {
        if (value.length > 15) {
          return value.substring(0, 15) + "...";
        } else {
          return value
        }
      } else {
        return ""
      }
    },
    quzifu(value) {
      return value.replace("_click_", "");
    },
  },
  components: {},
  data() {
    return {
      listLoading: false,
      tableData: [],
      columnNamearr: [],
      multipleSelection: [], // 已选数据
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      infoDialog: false,
      jsontext: null,
      datainfo: {}, // 打开的弹窗对象
    }
  },

  created() {
    this.getList()
  },

  methods: {
    // 获取数据
    getList() {
      this.columnNamearr = [];
      this.listLoading = true
      ajax_dataworkconfigcolumn(this.infotableName).then(response => {
        if (response.code == 1) {
          this.listLoading = false
          this.tableData = response.data
          for (var key in this.tableData[0]) {
            this.columnNamearr.push({
              label: key, show: true,
            })
          }

          this.total = response.data.totalCount
        } else {
          this.listLoading = false
        }
      })
    },
    indexOfstr(val) {
      val = val + ""
      if (val.indexOf("_click_") != -1) {
        return true
      } else {
        return false
      }
    },

    tablelistdis(obj) {
      if (obj.show == true) {
        obj.show = false;
      } else {
        obj.show = true;
      }
    },

    // 全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log(this.multipleSelection)
    },


  }
}
</script>

<style lang="scss" scoped>
.link {
  color: #646cf5;
  cursor: pointer;
}
.shaixuanlielist {
  float: left;
  width: 33%;
  cursor: pointer;
  line-height: 30px;
}
.shaixuantextcolor {
  color: #46a6ff;
}
</style>